import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectIsQualifiedForLibrary } from "../../selectors/selectLibraryInfo";
import { ButtonNormalSmall } from "../generic/common/ButtonNormalSmall";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var _HudButtonLibrary = function (_a) {
    var openLibraryMenu = _a.openLibraryMenu, canUseLibrary = _a.canUseLibrary;
    return (React.createElement(ButtonNormalSmall, { onClick: openLibraryMenu, className: !canUseLibrary ? IdStyles.StateLocked : "" },
        React.createElement("div", { className: "flex flex--guts w100 h100" },
            React.createElement(Icon, { icon: IdIcon.FarmBoostersIcn, styleId: IdStyles.IconLarge, isLocked: !canUseLibrary }))));
};
var mapState = function (state) { return ({
    canUseLibrary: selectIsQualifiedForLibrary(state),
}); };
var mapDispatch = function (dispatch) { return ({
    openLibraryMenu: function () { return dispatch(actionModalOpen(IdModal.Library)); },
}); };
export var HudButtonLibrary = connect(mapState, mapDispatch)(_HudButtonLibrary);



//////////////////
// WEBPACK FOOTER
// ./src/features/library/HudButtonLibrary.tsx
// module id = 2268
// module chunks = 3